export default __webpack_public_path__ + "static/media/apple.816f67af.svg";